import { Action } from './pool/action';
import type { AppDispatch } from '@client/store';
import type { GenericList } from '@sda/helpers/helpers.types';
import type { AnyAction } from '@reduxjs/toolkit';

/**
 * Utility class for pooling multiple actions together
 * Only used for when the same action may be dispatched from multiple places and where a delay would not be noticed
 */
export class Pool {
  dispatchFunction: AppDispatch;

  actions: GenericList<Action> = {};

  constructor(dispatchFunction: AppDispatch) {
    this.dispatchFunction = dispatchFunction;
  }

  dispatch = (action: AnyAction): void => {
    const { type } = action;

    if (!this.actions[type]) {
      this.actions[type] = new Action(action, this.dispatchFunction);
    } else {
      this.actions[type].add(action);
    }
  };
}
